// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@sc/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { orderSummaryStyles } from "@sc/Overrides/Widgets/OnePageCheckout/OnePageCheckoutOrderSummary";
import { css } from "styled-components";

orderSummaryStyles.wrapper = {
    ...orderTotalDisplaySharedStyles.wrapper,
};

orderSummaryStyles.actionsWrapper = {
    css: css`
        margin-top: 16px;
    `,
};

orderSummaryStyles.placeOrderButton = {
    sizeVariant: "large",
    variant: "primary",
    css: css`
        width: 100%;
    `,
};

orderSummaryStyles.submitForApprovalButton = {
    sizeVariant: "large",
    variant: "primary",
    css: css`
        width: 100%;
    `,
};
orderSummaryStyles.notify = {
    css: css`
        margin-top: 16px;
        margin-bottom: 0;
    `,
};
